import { jotWorkerApi as api } from "../../jotWorkerApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProductGuideTopics: build.query<
      GetProductGuideTopicsApiResponse,
      GetProductGuideTopicsApiArg
    >({
      query: () => ({ url: `/api/product-guide-v2/topics` }),
    }),
    searchProductGuideArticles: build.query<
      SearchProductGuideArticlesApiResponse,
      SearchProductGuideArticlesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/product-guide-v2/search`,
        params: {
          q: queryArg.q,
        },
      }),
    }),
    getProductGuideArticle: build.query<
      GetProductGuideArticleApiResponse,
      GetProductGuideArticleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/product-guide-v2/articles/${queryArg.topic}/${queryArg.id}`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedProductGuideApi };
export type GetProductGuideTopicsApiResponse =
  /** status 200 Ordered topics with article summaries, without bodies or pagination. */ ProductGuideTopics;
export type GetProductGuideTopicsApiArg = void;
export type SearchProductGuideArticlesApiResponse =
  /** status 200 Ranked article matches, including content in conditional branches the frontend may hide. */ ProductGuideSearchResult[];
export type SearchProductGuideArticlesApiArg = {
  /** English full-text search; unquoted terms are ANDed, quotes match phrases, OR and minus are supported. Close title/alias matches are a fallback only when full-text search finds nothing. At most 500 characters and 20 whitespace-separated tokens are used. Empty queries return no results. */
  q?: string;
};
export type GetProductGuideArticleApiResponse =
  /** status 200 Markdoc text with source frontmatter and a generated media URL map. */ string;
export type GetProductGuideArticleApiArg = {
  /** Published topic slug; an incorrect topic returns 404. */
  topic: string;
  /** Stable article ID, the second segment of the returned article slug. */
  id: string;
};
export type ProductGuideTopicReference = {
  slug: string;
  title: string;
};
export type ProductGuideArticleSummary = {
  /** Stable, globally unique article ID. */
  id: string;
  /** Canonical {topic}/{article_id} slug. Preserve the slash when building an article URL. */
  slug: string;
  title: string;
  /** Opaque approved publication version. */
  version: string;
  /** Content verification date in YYYY-MM-DD format, or null when unverified. */
  lastVerified: string | null;
  summary?: string;
  kind?:
    | "hub"
    | "task"
    | "workflow"
    | "reference"
    | "setup"
    | "troubleshooting"
    | "stub";
};
export type ProductGuideTopic = ProductGuideTopicReference & {
  articles: ProductGuideArticleSummary[];
};
export type ProductGuideTopics = {
  topics: ProductGuideTopic[];
};
export type ProductGuideError = {
  error: string;
};
export type ProductGuideSearchResult = ProductGuideArticleSummary & {
  topic: ProductGuideTopicReference;
  excerpt: string;
};
